import { useQuery } from "@tanstack/react-query";
import sheetsService from "services/admin/sheetsService";

export const useGetDriveFiles = () => {
    return useQuery({
        queryKey: ['getDriveFiles'],
        queryFn: async () => {
            return sheetsService.getFiles()
        },
        refetchOnWindowFocus: false,
        select: (data) => data.data
    })
}